import { createSlice } from '@reduxjs/toolkit'

const TorkNoteTypeSlice = createSlice({
  name: 'TorkNoteTypeSlice',
  initialState: [],
  reducers: {
    setNoteTypes(state, action) {
      return [...action.payload];
    }
  }
})

export const { setNoteTypes } = TorkNoteTypeSlice.actions
export default TorkNoteTypeSlice.reducer
